import {
  Button,
  Card,
  CardActions,
  CardContent,
  CardHeader,
  CircularProgress,
} from "@mui/material";
import {  useState } from "react";
import {  useHistory } from "react-router-dom";
import { SubmitButton } from "../../../components/buttons";
import axios from "axios";
import secureLocalStorage from "react-secure-storage";

const ConfirmAvailability = (props) => {
  const [showIcon, setIcon] = useState("");
  const [loading, setLoading] = useState(false);
  const [comment, setComment] = useState("");

  let search = props.location.search;
  let params = new URLSearchParams(search);
  let meetingId = params.get("meetingId");
  let email = params.get("email");
  let status = params.get("status");
  let history = useHistory();

  const onSubmit = async (e) => {
    e.preventDefault();
    try {
      if (status && meetingId && email) {
        const URL = `/api/meeting/confirm-availability/?meetingId=${meetingId}&status=${status}&email=${email}`;
        const header = {
          headers: { "access-token": secureLocalStorage.getItem("token") },
        };
        const response = await axios.post(URL, { comment }, header);
        if (response.status === 200) {
          setIcon(status);
        }
      }
    } catch (error) {
      if (error) {
        setIcon(error.response.data.message);
      }
    }
    setLoading(true);

  };
  return (
    <div className="container">
      <div className="row justify-content-center mt-4">
        <form onSubmit={(e) => {
          onSubmit(e);

        }}>
          <Card className={"mt-3 mb-3"} variant={"outlined"}>
            <div className="row justify-content-center">
              <p className="text-center fa-2x text-capitalize"> {showIcon}</p>

              <p className="text-center">
                {showIcon === "confirmed" && (
                  <i
                    className="fa fa-check-circle fa-6x  text-success me-2"
                    style={{ width: "40vh" }}
                  />
                )}
                {showIcon === "denied" && (
                  <i className="fa fa-times-circle fa-6x  text-danger me-2" />
                )}
              </p>
              {!showIcon && (
                <div className="col-md-9">
                  <CardHeader
                    title={"Add Comment"}
                    titleTypographyProps={{ variant: "h6" }}
                    className={"row justify-content-center"}
                  />
                  <CardContent>
                    <textarea
                    style={{width:"100%"}}
                      rows={6}
                      cols={4}
                      placeholder={"Type here... "}
                      value={comment}
                      required={true}
                      onChange={(e) => setComment(e.target.value)}
                    />
                  </CardContent>
                </div>
              )}
            </div>

            {!showIcon && (
              <CardActions className={"float-end"}>
                <Button color={"error"} onClick={() => history.goBack()}>
                  Cancel
                </Button>
                {loading ? (
                  <CircularProgress />
                ) : (
                  <SubmitButton
                    name={"Submit"}
                  />
                )}
              </CardActions>
            )}
          </Card>
        </form>
      </div>
    </div>
  );
};
export default ConfirmAvailability;
